import { useQuery } from "@hooks/useQuery";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useNotification } from "~/Hooks/useNotification";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { fields } from "../../constants";
import { useLagsSection3 } from "../../Pages.hook";

export const LagsSection3 = () => {
  const { openToast } = useNotification();
  const query = useQuery();
  const navigate = useNavigate();
  const subActiveTab = query.get("subActiveTab");

  const {
    data: singleCabinLuggagePolicy,
    isLoading: isLoadingSingleCabinLuggagePolicy,
    refetch: refetchsingleCabinLuggagePolicy,
  } = useLagsSection3();
  const {
    data: travellersInfoById,
    isLoading: isLoadingTravellersInfoById,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    } else {
      refetchsingleCabinLuggagePolicy();
    }
  }, [query.get("id")]);

  const singleCabinLuggagePolicyFormConfig: FormConfig = {
    initialValues: {
      pdf_url: travellersInfoById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "faqpdf.pdf",
              status: "done",
              url: travellersInfoById?.payload?.pdf_url,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "faqpdf.pdf",
              status: "done",
              url: singleCabinLuggagePolicy?.[0]?.pdf_url,
            },
          ]),
      english_title: decodeHTML(
        typeof (travellersInfoById?.payload?.english_title ?? singleCabinLuggagePolicy?.[0]?.english_title) === "string"
          ? (travellersInfoById?.payload?.english_title ?? singleCabinLuggagePolicy?.[0]?.english_title)
          : ""
      ),

      malay_title: decodeHTML(
        typeof (travellersInfoById?.payload?.malay_title ?? singleCabinLuggagePolicy?.[0]?.malay_title) === "string"
          ? (travellersInfoById?.payload?.malay_title ?? singleCabinLuggagePolicy?.[0]?.malay_title)
          : ""
      ),

      mandarin_title: decodeHTML(
        typeof (travellersInfoById?.payload?.mandarin_title ?? singleCabinLuggagePolicy?.[0]?.mandarin_title) ===
          "string"
          ? (travellersInfoById?.payload?.mandarin_title ?? singleCabinLuggagePolicy?.[0]?.mandarin_title)
          : ""
      ),

      description_english_1: decodeHTML(
        typeof (
          travellersInfoById?.payload?.description_english_1 ?? singleCabinLuggagePolicy?.[0]?.description_english_1
        ) === "string"
          ? (travellersInfoById?.payload?.description_english_1 ?? singleCabinLuggagePolicy?.[0]?.description_english_1)
          : ""
      ),

      description_malay_1: decodeHTML(
        typeof (
          travellersInfoById?.payload?.description_malay_1 ?? singleCabinLuggagePolicy?.[0]?.description_malay_1
        ) === "string"
          ? (travellersInfoById?.payload?.description_malay_1 ?? singleCabinLuggagePolicy?.[0]?.description_malay_1)
          : ""
      ),

      description_mandarin_1: decodeHTML(
        typeof (
          travellersInfoById?.payload?.description_mandarin_1 ?? singleCabinLuggagePolicy?.[0]?.description_mandarin_1
        ) === "string"
          ? (travellersInfoById?.payload?.description_mandarin_1 ??
              singleCabinLuggagePolicy?.[0]?.description_mandarin_1)
          : ""
      ),

      download_button_text_english: decodeHTML(
        typeof (
          travellersInfoById?.payload?.download_button_text_english ??
          singleCabinLuggagePolicy?.[0]?.download_button_text_english
        ) === "string"
          ? (travellersInfoById?.payload?.download_button_text_english ??
              singleCabinLuggagePolicy?.[0]?.download_button_text_english)
          : ""
      ),

      download_button_text_malay: decodeHTML(
        typeof (
          travellersInfoById?.payload?.download_button_text_malay ??
          singleCabinLuggagePolicy?.[0]?.download_button_text_malay
        ) === "string"
          ? (travellersInfoById?.payload?.download_button_text_malay ??
              singleCabinLuggagePolicy?.[0]?.download_button_text_malay)
          : ""
      ),

      download_button_text_mandarin: decodeHTML(
        typeof (
          travellersInfoById?.payload?.download_button_text_mandarin ??
          singleCabinLuggagePolicy?.[0]?.download_button_text_mandarin
        ) === "string"
          ? (travellersInfoById?.payload?.download_button_text_mandarin ??
              singleCabinLuggagePolicy?.[0]?.download_button_text_mandarin)
          : ""
      ),
    },
    fields: fields.lagsDisclaimerContent,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image", "pdf_url"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);
          if (res) data[key] = res.response.data;
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else if (Array.isArray(field) && field.length === 0) {
          data[key] = "";
        } else if (!field) {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Pages",
      subModule: "travellersInfo_lagsAndRestrictedItems_lags_lagsDisclaimerContent",
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...data,
        published: true,
      },
      status: status,
    };
    console.log(payload, "payload");
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    // <ContentWrapper>
    <DynamicForm
      isLoading={isLoadingSingleCabinLuggagePolicy || isLoadingTravellersInfoById}
      config={singleCabinLuggagePolicyFormConfig}
      onSubmit={(data, buttonValue, reviewNotes) =>
        onSubmit(
          data,
          `${eramanHost}/api/lags/section-three/${singleCabinLuggagePolicy?.[0]?.nid || travellersInfoById?.payload?.id}`,
          "UPDATE",
          "PATCH",
          buttonValue === "save" ? "DRAFT" : "PENDING",
          reviewNotes
        )
      }
    />
    // </ContentWrapper>
  );
};
